<div class="main-container">
  <div class="cards">
    <div class="drawer-card new-comment-card">
      <h3 class="drawer-card-header">New Comment</h3>
      <form
        [formGroup]="commentForm"
        (ngSubmit)="addComment()"
        class="drawer-card-body input-area"
      >
        <textarea
          class="field comment-textarea"
          formControlName="text"
          placeholder="Write a comment…"
          aria-label="Comment"
          rows="3"
        ></textarea>
        <input
          class="field"
          formControlName="storeContact"
          placeholder="Store contact (optional)"
          aria-label="Store contact"
        />
        <button
          class="add-button"
          type="submit"
          [disabled]="commentForm.invalid"
        >
          Add Comment
        </button>
      </form>
    </div>

    <!-- EXT-6537: one section per type, each with a count, only its latest
         entry, and Show N more / Show less. -->
    @for (category of sortedComments(); track category.category) {
      <section class="drawer-card">
        <h3 class="drawer-card-header">
          {{ categoryLabel(category.category) }}
          <span class="drawer-card-badge">{{ category.comments.length }}</span>
        </h3>

        <div class="drawer-card-body comment-list">
          @for (comment of visibleComments(category); track $index) {
            <div class="comment-item">
              <div class="comment-meta">
                <strong class="comment-user">{{ comment.user || "—" }}</strong>
                <span class="comment-time">{{
                  formatDateTime(comment.dateTime)
                }}</span>
                @if (
                  canEdit(category.category, comment) && !isEditing(comment)
                ) {
                  <span class="comment-actions">
                    <button
                      type="button"
                      class="link-button"
                      (click)="startEdit(comment)"
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      class="link-button"
                      (click)="deleteComment(comment)"
                    >
                      Delete
                    </button>
                  </span>
                }
              </div>

              @if (isEditing(comment)) {
                <div class="edit-area">
                  <textarea
                    class="edit-textarea"
                    [value]="editDraftText()"
                    (input)="onEditDraftChange($any($event.target).value)"
                  ></textarea>
                  <span class="edit-actions">
                    <button
                      type="button"
                      mat-flat-button
                      color="primary"
                      [disabled]="!editDraftText().trim()"
                      (click)="saveEdit(comment)"
                    >
                      Save
                    </button>
                    <button type="button" mat-button (click)="cancelEdit()">
                      Cancel
                    </button>
                  </span>
                </div>
              } @else {
                <p class="comment-text">{{ comment.commentText }}</p>
              }
            </div>
          }
          @if (category.comments.length > COMMENTS_PREVIEW_COUNT) {
            <button
              type="button"
              class="show-more"
              (click)="toggleExpanded(category.category)"
            >
              {{
                isExpanded(category.category)
                  ? "Show less"
                  : "Show " +
                    (category.comments.length - COMMENTS_PREVIEW_COUNT) +
                    " more"
              }}
            </button>
          }
        </div>
      </section>
    } @empty {
      <p>No comments yet.</p>
    }
  </div>
</div>
